






























































































import {Component, Vue} from "vue-property-decorator";
import {Getter, Mutation} from "vuex-class";
import axios from "axios";
import TableComponent from "@/components/features/tables/TableComponent.vue";
import moment from "moment";
import NewFloatButtonComponent from "@/components/features/buttons/NewFloatButtonComponent.vue";
import ArchiveIconButtonComponent from "@/components/features/buttons/ArchiveIconButtonComponent.vue";
import HelpButtonComponent from "@/components/features/buttons/HelpButtonComponent.vue";



interface Dataset {
  id: number;
  name: string;
}

interface Report {
  id: number;
  name: string;
  dataset: Dataset;
}

const ANY_DATASET: Dataset = {id: -1, name: "All datasets"};

@Component({
  components: {
    TableComponent,
    NewFloatButtonComponent,
    ArchiveIconButtonComponent,
    HelpButtonComponent
  }
})

export default class ListReportsView extends Vue {

  name = "ListReportsView";
  dataLoaded = false;
  reports: Report[] = [];
  datasets: Dataset[] = [];
  filterDataset: Dataset = ANY_DATASET;

  // map getters
  @Getter base_url !: any;
  @Getter auth_header !: any;
  @Getter domain !: any;

  @Mutation SET_BREADCRUMB!: (_: any) => any; //TODO: add type

  moment(val: any) {
    return moment(val);
  }

  get filteredReports() {
    if (this.filterDataset == ANY_DATASET) {
      return this.reports;
    }
    return this.reports.filter(report => report.dataset.id == this.filterDataset.id)
  }

  mounted() {
    this.setBreadcrumb();

    this.loadReports();
  }

  loadReports() {
    axios.get(this.base_url + 'experiments/reports?archived=false',
        {
          headers: this.auth_header,
          params: this.$route.query
        }).then(response => {
      console.log(response.data)
      this.dataLoaded = true;
      this.reports = response.data;
      let datasets: Record<any, any> = {};
      for (let report of this.reports) {
        datasets[report.dataset.id] = report.dataset;
      }
      this.datasets = []
      this.datasets.push(ANY_DATASET);
      for (let datasetId in datasets) {
        this.datasets.push(datasets[datasetId])
      }
    })
        .catch(error => {
          console.log("Something went wrong getting reports", error);
        })
  }

  //original methods
  setBreadcrumb() {
    this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
  }

  handleReportNameClick(report: Report) {
    this.$router.push({name: "EditReportView", params: {id: "" + report.id}});
  }

  handleDatasetNameClick(dataset: Dataset) {
    if (this.filterDataset != ANY_DATASET) {
      this.filterDataset = ANY_DATASET;
    } else {
      this.filterDataset = dataset;
    }
  }

  askAndArchiveReport(report: Report) {
    console.log(report);
    this.$dialog.confirm({
      title: 'Delete Report',
      message: 'Are you sure you want to <b>delete</b> this Report? This action cannot be undone.',
      confirmText: 'Delete Report',
      type: 'is-warning',
      hasIcon: true,
      onConfirm: () => this.doReportArchive(report)
    })
  }

  doReportArchive(report: Report) {
    axios.patch(this.base_url + 'experiments/reports/' + report.id + '/archive',
        {},
        {
          headers: this.auth_header
        }).then(response => {
      console.log("Archive successful", response.data);
      this.loadReports();
      // ...
    })
        .catch(error => {
          console.log("Something went wrong archiving report", error);
        })
  }

}
